import type { ReactNode } from 'react';
import Close from '@mui/icons-material/Close';
import { Logo, FormActions } from '@practium/ui';
import type { FormPageMode } from '@practium/ui';
import styles from './FormModal.module.css';

export type FormModalMode = FormPageMode;

export interface FormModalProps {
	isOpen: boolean;
	title: string;
	onClose: () => void;
	mode?: FormModalMode;
	onSave?: () => void;
	onCancel?: () => void;
	isSaving?: boolean;
	saveLabel?: string;
	onEdit?: () => void;
	onDelete?: () => void;
	children: ReactNode;
}

export const FormModal = ({
	isOpen,
	title,
	onClose,
	mode = 'add',
	onSave,
	onCancel,
	isSaving = false,
	saveLabel = 'Salvar',
	onEdit,
	onDelete,
	children,
}: FormModalProps) => {
	if (!isOpen) return null;

	return (
		<div className={styles.overlay}>
			<div className={styles.modal}>
				<div className={styles.header}>
					<div className={styles.headerTop}>
						<Logo className={styles.logo} />
						<button type="button" className={styles.closeButton} onClick={onClose}>
							<Close fontSize="medium" />
						</button>
					</div>
					<h2 className={styles.title}>{title}</h2>
				</div>

				<div className={styles.body}>{children}</div>

				<div className={styles.footer}>
					<FormActions
						mode={mode}
						onDelete={onDelete}
						onEdit={onEdit}
						onCancel={onCancel}
						onSave={onSave}
						isLoading={isSaving}
						saveText={saveLabel}
					/>
				</div>
			</div>
		</div>
	);
};
